import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import TopBar from './components/TopBar';
import NavBar from './components/NavBar';

const useStyles = makeStyles({
  container: {
    position: 'relative',
    left: (props) => props.drawerWidth,
    margin: '0 !important',
    padding: '10px !important',
    height: 'calc(100vh - 64px)',
    width: (props) => `calc(100% - ${props.drawerWidth}px)`,
  },
});

function MainLayout(props) {
  const { children } = props;
  const [drawerWidth, setDrawerWidth] = useState(240);
  const classes = useStyles({ drawerWidth });

  const toggleDrawer = () => {
    const newWidth = drawerWidth === 240 ? 56 : 240;
    setDrawerWidth(newWidth);
  };

  return (
    <Box>
      <TopBar />
      <NavBar
        drawerWidth={drawerWidth}
        toggleDrawer={toggleDrawer}
      />
      <Box className={classes.container}>
        {children}
      </Box>
    </Box>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;
